/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITeamResponse } from './ITeamResponse';
import {
    ITeamResponseFromJSON,
    ITeamResponseFromJSONTyped,
    ITeamResponseToJSON,
    ITeamResponseToJSONTyped,
} from './ITeamResponse';

/**
 * 
 * @export
 * @interface UpdateUniversalTeamResponse
 */
export interface UpdateUniversalTeamResponse {
    /**
     * 
     * @type {ITeamResponse}
     * @memberof UpdateUniversalTeamResponse
     */
    team: ITeamResponse;
}

/**
 * Check if a given object implements the UpdateUniversalTeamResponse interface.
 */
export function instanceOfUpdateUniversalTeamResponse(value: object): value is UpdateUniversalTeamResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function UpdateUniversalTeamResponseFromJSON(json: any): UpdateUniversalTeamResponse {
    return UpdateUniversalTeamResponseFromJSONTyped(json, false);
}

export function UpdateUniversalTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUniversalTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': ITeamResponseFromJSON(json['team']),
    };
}

export function UpdateUniversalTeamResponseToJSON(json: any): UpdateUniversalTeamResponse {
    return UpdateUniversalTeamResponseToJSONTyped(json, false);
}

export function UpdateUniversalTeamResponseToJSONTyped(value?: UpdateUniversalTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': ITeamResponseToJSON(value['team']),
    };
}

